// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"94ae9005","455":"b603b09c","488":"070a9aa7","566":"d06618fb","602":"fe0747e7","607":"f47f92c4","773":"92daf604","880":"f4589da9","990":"d6dad3fa"}[chunkId] + ".chunk.js";
};